module.exports = __webpack_public_path__ + "static/valleyview-logo-687b5c85cffb5aad222f79f350a1841b.jpg";